/**
 * Judaica Builder v10
 * Reads config from <script type="application/json"> — immune to DOM parsing issues
 */
;(function () {
  'use strict';

  /* DEBUG — remove after fix */
  console.log('[JB] Script loaded v' + new Date().getTime());
  document.querySelectorAll('[data-judaica-builder]').forEach(function(w) {
    var sid = w.getAttribute('data-section-id') || 'NO-ID';
    console.log('[JB] Found builder div, section-id:', sid);
    console.log('[JB] window.__JBConfigs exists:', !!window.__JBConfigs);
    console.log('[JB] Config for section:', window.__JBConfigs ? !!window.__JBConfigs[sid] : false);
    /* Force a test message in the body */
    var body = w.querySelector('[data-jb-body]');
    if (body) {
      body.innerHTML = '<p style="padding:20px;color:green">JS עובד ✅ section: ' + sid + '</p>';
    } else {
      console.error('[JB] body element [data-jb-body] NOT FOUND in wrap');
    }
  });

  function boot() {
    document.querySelectorAll('[data-judaica-builder]').forEach(function(wrap) {
      try {
        var sid = wrap.getAttribute('data-section-id') || 'NO-ID';
        var hasCfg = !!(window.__JBConfigs && window.__JBConfigs[sid]);
        console.log('[JB] initBuilder: section=', sid, 'hasCfg=', hasCfg);
        if (!hasCfg) {
          var body = wrap.querySelector('[data-jb-body]');
          if (body) body.innerHTML = '<div style="padding:20px;background:#fff3cd;color:#856404;border:1px solid #ffc107;margin:10px;border-radius:6px">'
            + '<strong>Config Missing</strong><br>'
            + 'Section ID: <code>' + sid + '</code><br>'
            + '__JBConfigs keys: <code>' + (window.__JBConfigs ? JSON.stringify(Object.keys(window.__JBConfigs)) : 'undefined') + '</code>'
            + '</div>';
        }
        initBuilder(wrap);
      } catch(e) {
        console.error('[JB] Error:', e);
        var body = wrap.querySelector('[data-jb-body]');
        if (body) body.innerHTML = '<div style="padding:20px;background:#f8d7da;color:#721c24;border:1px solid #f5c6cb;margin:10px;border-radius:6px">'
          + '<strong>JS Error:</strong> ' + e.message + '<br><small>' + e.stack + '</small>'
          + '</div>';
      }
    });
  }

  function initBuilder(wrap) {
    /* ── Read config: window.__JBConfigs (primary) or script tag (fallback) ── */
    var sectionId = wrap.getAttribute('data-section-id') || '';
    var cfg = null;

    /* Primary: window variable (avoids script tag parsing issues) */
    if (window.__JBConfigs && window.__JBConfigs[sectionId]) {
      cfg = window.__JBConfigs[sectionId];
      console.log('[JB] Config loaded from window.__JBConfigs');
    }

    /* Fallback: script[data-jb-config] tag */
    if (!cfg) {
      var configEl = wrap.querySelector('script[data-jb-config]');
      if (configEl) {
        try {
          cfg = JSON.parse(configEl.textContent);
          console.log('[JB] Config loaded from script tag');
        } catch(e) {
          console.error('[JB] JSON parse error:', e);
        }
      }
    }

    if (!cfg) {
      console.error('[JB] No config found for section:', sectionId);
      /* Show visible error in body */
      var bodyEl = wrap.querySelector('[data-jb-body]');
      if (bodyEl) {
        bodyEl.innerHTML = '<div style="padding:30px;color:#c00;font-family:sans-serif">'
          + '<strong>Builder Error:</strong> Config not found for section: ' + sectionId
          + '<br><small>Check that judaica-builder.js is the latest version.</small>'
          + '</div>';
      }
      return;
    }

    var TYPE       = cfg.type        || 'tallit';
    var VARIANT    = parseInt(cfg.variantId || '0', 10) || 0;
    var BASE_PRICE = parseInt(cfg.basePrice || '0', 10) || 0;
    var CURRENCY   = cfg.currency    || '₪';
    var CART_URL   = cfg.cartUrl     || '/cart/add.js';
    var CART_PAGE  = cfg.cartPage    || '/cart';

    /* ── UI strings from locale ── */
    var T = Object.assign({
      next:             cfg.labels.next,
      next_arrow:       cfg.labels.next_arrow,
      back:             cfg.labels.back,
      back_arrow:       cfg.labels.back_arrow,
      to_summary:       cfg.labels.to_summary,
      add_to_cart:      cfg.labels.add_to_cart,
      continue_to_cart: cfg.labels.continue_to_cart,
      build_again:      cfg.labels.build_again,
      your_choices:     cfg.labels.your_choices,
      price:            cfg.labels.price,
      base_price:       cfg.labels.base_price,
      extras:           cfg.labels.extras,
      total:            cfg.labels.total,
      summary:          cfg.labels.summary,
      choices:          cfg.labels.choices,
      step:             cfg.labels.step,
      of:               cfg.labels.of,
      optional:         cfg.labels.optional,
      recommended:      cfg.labels.recommended,
      no_choices:       cfg.labels.no_choices,
      please_select:    cfg.labels.please_select,
      please_select_field: 'יש לבחור %s לפני המשך',
      loading:          cfg.labels.loading,
      error:            cfg.labels.error,
      retry:            cfg.labels.retry,
      select_previous:  cfg.labels.select_previous,
      added_tallit:     'הטלית נוספה לסל!',
      added_chain:      'השרשרת נוספה לסל!',
      product_preview:  cfg.labels.product_preview,
      configure_variant:cfg.labels.configure_variant,
      tallit:           cfg.labels.tallit,
      chain:            cfg.labels.chain,
    }, cfg.strings || {});

    /* Remove hidden options (empty labels or hidden:true) */
    function cleanOptions(opts) {
      return (opts || []).filter(function(o) { return o.label && !o.hidden; });
    }
    function cleanSteps(steps) {
      return (steps || []).map(function(s) {
        var out = Object.assign({}, s);
        out.options  = cleanOptions(s.options);
        out.subSteps = (s.subSteps || []).map(function(sub) {
          var o2 = Object.assign({}, sub);
          o2.options = cleanOptions(sub.options);
          return o2;
        });
        return out;
      });
    }
    var STEPS = cleanSteps(cfg.steps || []);

    console.log('[JB] Loaded', STEPS.length, 'steps, base price', BASE_PRICE, 'variant', VARIANT);

    /* ── State ── */
    var S = { step: 0, sel: {}, adds: {} };

    function fmt(n) { return CURRENCY + Number(n).toLocaleString('he-IL'); }

    function calcTotal() {
      var t = BASE_PRICE;
      for (var k in S.adds) if (S.adds.hasOwnProperty(k)) t += S.adds[k];
      return t;
    }

    function evalCond(expr) {
      if (!expr) return true;
      try { return !!(new Function('sel', 'return !!(' + expr + ')')(S.sel)); }
      catch(e) { return true; }
    }

    function visibleSteps() {
      return STEPS.filter(function(s) { return evalCond(s.showWhen || null); });
    }

    function visibleSubSteps(step) {
      return (step.subSteps || []).filter(function(sub) { return evalCond(sub.showWhen || null); });
    }

    function clearInvisibleSubs(step) {
      if (step.type !== 'multi') return;

      /* Group by key — only clear if ALL sub-steps with this key are invisible.
         Multiple sub-steps can share the same key (e.g. ataraColor has one per fabric).
         If any ONE is visible, keep the value. */
      var keyVis = {};
      (step.subSteps || []).forEach(function(sub) {
        var vis = evalCond(sub.showWhen || null);
        if (keyVis[sub.key] === undefined) {
          keyVis[sub.key] = vis;
        } else {
          keyVis[sub.key] = keyVis[sub.key] || vis;
        }
      });

      Object.keys(keyVis).forEach(function(key) {
        if (!keyVis[key]) {
          delete S.sel[key];
          delete S.adds[key];
        }
      });
    }

    var $ = function(sel) { return wrap.querySelector(sel); };

    /* ══════════════════ RENDER ══════════════════ */
    function render() {
      var steps = visibleSteps();
      var cur   = S.step;
      var isSummary = cur >= steps.length;

      if (!isSummary && steps[cur]) clearInvisibleSubs(steps[cur]);

      renderDots(steps, cur);
      renderProgress(steps, cur, isSummary);

      var body = $('[data-jb-body]');
      if (body) body.innerHTML = isSummary ? buildSummary(steps) : buildStep(steps[cur], cur, steps.length);

      renderPreview(steps);
      renderFooter(cur, steps.length, isSummary);
    }

    function renderDots(steps, cur) {
      var nav = $('[data-jb-dots]');
      if (!nav) return;
      var total = steps.length;
      var dw = Math.max(14, Math.min(26, Math.floor(200 / (total + 1))));
      nav.innerHTML = steps.map(function(s, i) {
        var cls = i === cur ? 'active' : (i < cur ? 'done' : '');
        var w   = i === cur ? 24 : dw;
        return '<div class="jbv4-dot ' + cls + '" style="width:' + w + 'px" data-goto="' + i + '" title="' + s.title + '"></div>';
      }).join('');
    }

    function renderProgress(steps, cur, isSummary) {
      var lbl  = $('[data-jb-step-name]');
      var meta = $('[data-jb-progress-lbl]');
      var total = steps.length;
      if (lbl)  lbl.textContent  = isSummary ? cfg.labels.summary : (steps[cur] ? steps[cur].title : '');
      if (meta) meta.textContent = isSummary ? (total + '/' + total) : ((cur + 1) + '/' + total);
    }

    /* ── Media for an option ── */
    function buildMedia(o) {
      if (o.img) return '<img src="' + o.img + '" alt="' + o.label + '" class="jbv4-opt-img" loading="lazy">';
      /* No image — show placeholder with first letter of label */
      var initial = o.label ? o.label.slice(0, 2) : '?';
      return '<div class="jbv4-opt-placeholder"><span class="jbv4-opt-initial">' + initial + '</span></div>';
    }

    /* ── Options grid ── */
    function buildOptGroup(key, options) {
      if (!options || !options.length) return '<p style="color:#aaa;font-size:12px;padding:8px 0">—</p>';
      /* Filter options that have their own showWhen condition */
      var visOpts = options.filter(function(o) { return !o.showWhen || evalCond(o.showWhen); });
      if (!visOpts.length) return '<p style="color:#aaa;font-size:12px;padding:8px 0">—</p>';
      return '<div class="jbv4-options">' + visOpts.map(function(o) {
        var sel   = S.sel[key] === o.label;
        var badge = o.priceAdd > 0 ? '<span class="jbv4-opt-price-badge">+' + fmt(o.priceAdd) + '</span>' : '';
        return '<div class="jbv4-option' + (sel ? ' selected' : '') + '" data-key="' + key + '" data-val="' + o.label + '" data-price-add="' + (o.priceAdd || 0) + '">'
          + buildMedia(o)
          + '<span class="jbv4-opt-label">' + o.label + '</span>'
          + (o.sub ? '<span class="jbv4-opt-sub">' + o.sub + '</span>' : '')
          + badge + '</div>';
      }).join('') + '</div>';
    }

    /* ── Color swatches ── */
    function buildColorGroup(key, options, recommendKey) {
      if (!options || !options.length) return '<p style="color:#aaa;font-size:12px;padding:8px 0">—</p>';
      var selectedType = recommendKey ? S.sel[recommendKey] : null;
      return '<div class="jbv4-colors">' + options.map(function(o) {
        var sel   = S.sel[key] === o.label;
        var inner = o.img ? '<img src="' + o.img + '" alt="' + o.label + '" class="jbv4-swatch-img">' : '';
        var style = o.img
          ? 'border-color:' + (o.border || '#ccc') + ';background:#f0f0f0'
          : o.hex
            ? 'background:' + o.hex + ';border-color:' + (o.border || o.hex)
            : 'background:#e8e8e8;border-color:#ccc';  /* no image, no hex — grey placeholder */
        var badge = o.priceAdd > 0 ? '<span class="jbv4-clr-price">+' + fmt(o.priceAdd) + '</span>' : '';
        /* Recommended badge — if this color matches the tallit type */
        var isRec = selectedType && o.matchTypes && o.matchTypes.indexOf(selectedType) >= 0;
        var recBadge = isRec ? '<span class="jbv4-rec-badge">'+cfg.labels.recommended+'</span>' : '';
        return '<div class="jbv4-color-item' + (sel ? ' selected' : '') + (isRec ? ' recommended' : '') + '" data-key="' + key + '" data-val="' + o.label + '" data-price-add="' + (o.priceAdd || 0) + '">'
          + '<div class="jbv4-swatch" style="' + style + '">' + inner + '</div>'
          + '<span class="jbv4-color-name">' + o.label + recBadge + '</span>'
          + badge + '</div>';
      }).join('') + '</div>';
    }

    /* ── Text input ── */
    function buildTextField(sub) {
      return (sub.note ? '<div class="jbv4-note">' + sub.note + '</div>' : '')
        + '<div class="jbv4-field"><label class="jbv4-label">' + sub.title
        + (!sub.req ? '<span class="jbv4-opt-badge">'+cfg.labels.optional+'</span>' : '') + '</label>'
        + '<input class="jbv4-input jbv4-txt-field" placeholder="' + (sub.placeholder || '') + '"'
        + ' value="' + (S.sel[sub.key] || '') + '" data-key="' + sub.key + '" /></div>';
    }

    /* ── Build a step ── */
    function buildStep(s, cur, total) {
      if (!s) return '<p style="color:#aaa;padding:20px">'+cfg.labels.loading+'</p>';
      var meta = '<div class="jbv4-step-meta">שלב ' + (cur + 1) + ' מתוך ' + total + (!s.req ? ' · אופציונלי' : '') + '</div>'
               + '<h2 class="jbv4-step-title">' + (s.title || '') + '</h2>'
               + (s.desc ? '<p class="jbv4-step-desc">' + s.desc + '</p>' : '');

      var inner = '';
      if (s.type === 'options') {
        inner = buildOptGroup(s.key, s.options);
      } else if (s.type === 'colors') {
        inner = buildColorGroup(s.key, s.options, s.recommendKey);
      } else if (s.type === 'text') {
        inner = buildTextField(s);
      } else if (s.type === 'multi') {
        var visSubs = visibleSubSteps(s);
        if (!visSubs.length) {
          inner = '<p style="color:#aaa;font-size:13px;padding:12px 0">'+cfg.labels.select_previous+'</p>';
        } else {
          visSubs.forEach(function(sub) {
            var filled  = !!(S.sel[sub.key]);
            var isNext  = !filled && sub.req && sub.type !== 'text';
            inner += '<div class="jbv4-sub-section' + (filled ? ' jbv4-sub-filled' : '') + (isNext ? ' jbv4-sub-next' : '') + '" data-sub-section="' + sub.key + '">';
            inner += '<h3 class="jbv4-sub-title">' + sub.title;
            if (filled && sub.type !== 'text') inner += ' <span class="jbv4-sub-check">✓</span>';
            inner += '</h3>';
            if (sub.type === 'options')      inner += buildOptGroup(sub.key, sub.options);
            else if (sub.type === 'colors')  inner += buildColorGroup(sub.key, sub.options, sub.recommendKey);
            else if (sub.type === 'text')    inner += buildTextField(sub);
            inner += '</div>';
          });
        }
      }

      return meta + (inner || '') + '<div class="jbv4-err" id="jbv4-err"></div>';
    }

    /* ── Collect all selected images for preview ── */
    function getLayerImages(steps) {
      var layers = [];
      steps.forEach(function(s) {
        function checkOpt(key, options) {
          if (!S.sel[key]) return;
          var opt = (options || []).filter(function(o) { return o.label === S.sel[key]; })[0];
          if (opt && opt.img) layers.push({ img: opt.img, label: S.sel[key] });
        }
        if (s.type === 'multi') {
          s.subSteps.forEach(function(sub) { checkOpt(sub.key, sub.options); });
        } else {
          checkOpt(s.key, s.options);
        }
      });
      return layers;
    }

    /* ── Build visual product preview (stacked PNGs) ── */
    function buildProductPreview(steps) {
      var layers = getLayerImages(steps);
      if (!layers.length) return '';

      var layerDivs = layers.map(function(l) {
        return '<img src="' + l.img + '" alt="' + l.label + '"'
          + ' style="position:absolute;inset:0;width:100%;height:100%;object-fit:contain;">';
      }).join('');

      return '<div class="jbv4-product-preview">'
        + '<div class="jbv4-preview-canvas">'
        + layerDivs
        + '</div>'
        + '<div class="jbv4-preview-layers">'
        + layers.map(function(l) {
            return '<div class="jbv4-layer-thumb" title="' + l.label + '">'
              + '<img src="' + l.img + '" alt="' + l.label + '">'
              + '</div>';
          }).join('<span class="jbv4-layer-plus">+</span>')
        + '</div>'
        + '<p class="jbv4-preview-hint">'+cfg.labels.product_preview_layers+'</p>'
        + '</div>';
    }

    /* ── Summary ── */
    function buildSummary(steps) {
      var label = TYPE === 'tallit' ? T.tallit : T.chain;
      var entries = [];
      /* Color→image variant map for back embroidery */
      var colorVariantKey = {
        'שחור': 'black', 'אפור כהה': 'black',
        'לבן': 'white', 'קרם': 'white', 'אפור בהיר': 'white',
        'כחול כהה': 'navy', 'כחול בהיר': 'navy',
        'זהב': 'gold', 'כסוף': 'gold', 'כתום': 'gold',
        'בורדו': 'bordeaux', 'אדום': 'bordeaux'
      };

      steps.forEach(function(s) {
        if (s.type === 'multi') {
          (s.subSteps || []).forEach(function(sub) {
            if (S.sel[sub.key]) {
              var opt = (sub.options || []).filter(function(o) { return o.label === S.sel[sub.key]; })[0];
              /* For back embroidery: try color-specific image */
              if (opt && sub.key === 'backEmbroidery' && opt.colorVariants && S.sel['backEmbColor']) {
                var vk = colorVariantKey[S.sel['backEmbColor']];
                var vImg = vk && opt.colorVariants[vk];
                if (vImg) opt = Object.assign({}, opt, { img: vImg });
              }
              entries.push({ title: sub.title, val: S.sel[sub.key], opt: opt });
            }
          });
        } else if (S.sel[s.key]) {
          var opt = (s.options || []).filter(function(o) { return o.label === S.sel[s.key]; })[0];
          entries.push({ title: s.title, val: S.sel[s.key], opt: opt });
        }
      });

      /* Build grid cards — 2 per row */
      var cards = entries.map(function(e) {
        var add = (e.opt && e.opt.priceAdd > 0)
          ? '<div class="jbv4-sum-card-price">+' + fmt(e.opt.priceAdd) + '</div>'
          : '';
        var media = '';
        if (e.isText) {
          return '<div class="jbv4-sum-card jbv4-sum-card-text">'
            + '<div class="jbv4-sum-card-label">' + e.title + '</div>'
            + '<div class="jbv4-sum-card-val">&ldquo;' + e.val + '&rdquo;</div>'
            + '</div>';
        }
        if (e.opt) {
          if (e.opt.img)      media = '<img src="' + e.opt.img + '" alt="' + e.val + '" class="jbv4-sum-card-img">';
          else if (e.opt.hex) media = '<div class="jbv4-sum-card-swatch" style="background:' + e.opt.hex + ';border-color:' + (e.opt.border||e.opt.hex) + '"></div>';
          else                media = '<div class="jbv4-sum-card-initial">' + (e.val||'').slice(0,2) + '</div>';
        }
        return '<div class="jbv4-sum-card">'
          + '<div class="jbv4-sum-card-media">' + media + '</div>'
          + '<div class="jbv4-sum-card-label">' + e.title + '</div>'
          + '<div class="jbv4-sum-card-val">' + e.val + '</div>'
          + add + '</div>';
      }).join('');

      var total  = calcTotal();
      var extras = total - BASE_PRICE;

      return '<div class="jbv4-sum-block">'
        + '<div class="jbv4-sum-head">'
        + '<span class="jbv4-sum-head-title">סיכום ' + label + '</span>'
        + '<span class="jbv4-sum-head-count">' + entries.length + ' בחירות</span>'
        + '</div>'
        + '<div class="jbv4-sum-grid">'
        + (cards || '<p style="color:#aaa;padding:16px;font-size:13px">'+cfg.labels.no_choices+'</p>')
        + '</div>'
        + '<div class="jbv4-sum-price-row">'
        + '<span>מחיר בסיס: ' + fmt(BASE_PRICE) + '</span>'
        + (extras > 0 ? '<span>תוספות: +' + fmt(extras) + '</span>' : '')
        + '</div>'
        + '<div class="jbv4-total"><span class="jbv4-total-label">'+cfg.labels.total+'</span><span class="jbv4-total-val">' + fmt(total) + '</span></div>'
        + '</div><div class="jbv4-err" id="jbv4-err"></div>';
    }

    /* ── Preview panel ── */
    function renderPreview(steps) {
      var rowsEl  = $('[data-jb-preview-rows]');
      var priceEl = $('[data-jb-price]');
      if (!rowsEl) return;
      var entries = [];
      steps.forEach(function(s) {
        if (s.type === 'multi') {
          (s.subSteps || []).forEach(function(sub) {
            if (S.sel[sub.key]) entries.push({ title: sub.title, val: S.sel[sub.key] });
          });
        } else if (S.sel[s.key]) {
          entries.push({ title: s.title, val: S.sel[s.key] });
        }
      });
      rowsEl.innerHTML = !entries.length
        ? '<div class="jbv4-preview-empty">'+cfg.labels.your_choices+'<br>'+cfg.labels.choices_here+'</div>'
        : entries.slice(-6).map(function(e) {
            var t = e.title.length > 12 ? e.title.slice(0, 12) + '…' : e.title;
            return '<div class="jbv4-preview-row"><span class="jbv4-preview-row-k">' + t + '</span><span class="jbv4-preview-row-v">' + e.val + '</span></div>';
          }).join('');
      if (priceEl) priceEl.textContent = fmt(calcTotal());
    }

    /* ── Footer ── */
    function renderFooter(cur, total, isSummary) {
      var back = $('[data-jb-back]');
      var next = $('[data-jb-next]');
      if (back) back.disabled = cur === 0;
      if (next) {
        next.textContent = isSummary ? T.add_to_cart : (cur === total - 1 ? T.to_summary : T.next_arrow);
        next.className   = 'jbv4-btn jbv4-btn-dark';
      }
    }

    /* ── Validate ── */
    function validate() {
      var steps = visibleSteps();
      var s = steps[S.step];
      if (!s) return true;
      if (s.type === 'multi') {
        var subs = visibleSubSteps(s);
        for (var i = 0; i < subs.length; i++) {
          if (subs[i].req && subs[i].type !== 'text' && !S.sel[subs[i].key]) {
            showErr(T.please_select_field.replace('%s', subs[i].title));
            return false;
          }
        }
        return true;
      }
      if (s.req && s.type !== 'text' && !S.sel[s.key]) {
        showErr(T.please_select);
        return false;
      }
      return true;
    }

    function showErr(msg) {
      var e = document.getElementById('jbv4-err');
      if (e) { e.textContent = msg; e.classList.add('show'); setTimeout(function() { e.classList.remove('show'); }, 3500); }
    }

    function saveTexts() {
      wrap.querySelectorAll('.jbv4-txt-field').forEach(function(t) {
        if (t.dataset.key) S.sel[t.dataset.key] = t.value;
      });
    }

    function goNext() {
      saveTexts();
      if (!validate()) return;
      var total = visibleSteps().length;
      if (S.step >= total) { doCart(); return; }
      S.step = Math.min(S.step + 1, total);
      render();
      wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function goBack() {
      saveTexts();
      S.step = Math.max(0, S.step - 1);
      render();
      wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /* ── Cart ── */
    function doCart() {
      if (!VARIANT) { alert(T.configure_variant); return; }
      var steps = visibleSteps();
      var props = { '_builder': TYPE, '_total': fmt(calcTotal()) };
      steps.forEach(function(s) {
        function addEntry(key, title, options) {
          if (!S.sel[key]) return;
          var opt = (options || []).filter(function(o) { return o.label === S.sel[key]; })[0];
          props[title] = S.sel[key] + (opt && opt.priceAdd > 0 ? ' (+' + fmt(opt.priceAdd) + ')' : '');
        }
        if (s.type === 'multi') {
          (s.subSteps || []).forEach(function(sub) { addEntry(sub.key, sub.title, sub.options); });
        } else { addEntry(s.key, s.title, s.options); }
      });
      var btn = $('[data-jb-next]');
      if (btn) { btn.disabled = true; btn.textContent = '...'; }
      fetch(CART_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: VARIANT, quantity: 1, properties: props })
      }).then(function(r) {
        if (!r.ok) return r.json().then(function(d) { throw new Error(d.description || d.message || r.status); });
        return r.json();
      }).then(function() { showSuccess(); })
        .catch(function(err) {
          showErr('שגיאה: ' + err.message);
          if (btn) { btn.disabled = false; btn.textContent = cfg.labels.retry; }
        });
    }

    function showSuccess() {
      var right = wrap.querySelector('.jbv4-right');
      if (!right) return;
      var icon  = TYPE === 'tallit' ? '🕍' : '📿';
      var label = TYPE === 'tallit' ? T.tallit : T.chain;
      right.innerHTML = '<div class="jbv4-success"><div class="jbv4-success-icon">' + icon + '</div>'
        + '<h2 class="jbv4-success-title">' + label + ' נוספה לסל!</h2>'
        + '<p class="jbv4-success-sub">סה״כ: ' + fmt(calcTotal()) + '</p>'
        + '<div class="jbv4-success-btns">'
        + '<a href="' + CART_PAGE + '" class="jbv4-btn jbv4-btn-dark">'+cfg.labels.continue_to_cart+'</a>'
        + '<button class="jbv4-btn" onclick="location.reload()">'+cfg.labels.build_again+'</button></div></div>';
    }

    /* ── Pulse the next button ── */
    function pulseNext() {
      var btn = $('[data-jb-next]');
      if (!btn) return;
      btn.classList.remove('jbv4-btn-pulse');
      void btn.offsetWidth;
      btn.classList.add('jbv4-btn-pulse');
    }

    /* ── After selection: scroll to next unfilled sub-step or pulse ── */
    function afterSelection() {
      var steps = visibleSteps();
      var s = steps[S.step];
      if (!s || s.type !== 'multi') { pulseNext(); return; }

      var subs = visibleSubSteps(s);

      /* find first unfilled required sub-step */
      var nextKey = null;
      for (var i = 0; i < subs.length; i++) {
        if (subs[i].req && subs[i].type !== 'text' && !S.sel[subs[i].key]) {
          nextKey = subs[i].key;
          break;
        }
      }

      if (nextKey) {
        /* Wait for render() to update DOM, then scrollIntoView */
        var tries = 0;
        function tryScroll() {
          tries++;
          var el = wrap.querySelector('[data-sub-section="' + nextKey + '"]');
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else if (tries < 8) {
            setTimeout(tryScroll, 60);
          }
        }
        setTimeout(tryScroll, 60);
      } else {
        pulseNext();
      }
    }

    /* ── Events ── */
    wrap.addEventListener('click', function(e) {

      /* Manual traversal — more reliable than closest() */
      function findParent(el, test) {
        var node = el;
        for (var i = 0; i < 8; i++) {
          if (!node || node === wrap) return null;
          if (test(node)) return node;
          node = node.parentElement;
        }
        return null;
      }

      /* Nav buttons */
      if (findParent(e.target, function(n) { return n.getAttribute && n.getAttribute('data-jb-next') !== null; })) { goNext(); return; }
      if (findParent(e.target, function(n) { return n.getAttribute && n.getAttribute('data-jb-back') !== null; })) { goBack(); return; }

      /* Step dots */
      var dot = findParent(e.target, function(n) { return n.classList && n.classList.contains('jbv4-dot') && n.classList.contains('done'); });
      if (dot) { saveTexts(); S.step = parseInt(dot.getAttribute('data-goto'), 10); render(); return; }

      /* Option/color selection */
      var opt = findParent(e.target, function(n) { return n.getAttribute && n.getAttribute('data-key') && n.getAttribute('data-val') !== null; });
      if (opt) {
        var key = opt.getAttribute('data-key');
        var val = opt.getAttribute('data-val');
        var add = parseInt(opt.getAttribute('data-price-add') || '0', 10) || 0;
        delete S.adds[key];
        S.sel[key] = val;
        if (add > 0) S.adds[key] = add;
        render();
        afterSelection();
        return;
      }
    });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();